











import Vue from 'vue'

import { SettingsPanelCustomCustomMixin } from './SettingsPanelCustomCustomMixin'
import SettingsPanelCustomSelectbox from '../SettingsPanelCustomSelectbox.vue'

import { WidgetSettingType, WidgetSettingsSelectbox } from '../../widgets/base/widget/WidgetInterface'

export default Vue.extend({
  mixins: [SettingsPanelCustomCustomMixin],
  components: {
    SettingsPanelCustomSelectbox
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: {}
    }
  },
  data() {
    const config = {
      selectedGroup: 'all'
    }

    this.syncConfigProperties(config, this.data)

    return {
      config
    }
  },
  computed: {
    availableGroups() {
      let selectedGroup: WidgetSettingsSelectbox = {
        title: 'Gruppe',
        type: WidgetSettingType.selectbox,
        options: [
          { label: 'Alle', value: 'all' },
          { label: 'Ohne Gruppe', value: 'none' },
        ],
        value: this.config.selectedGroup,
      }

      for (const key in this.$store.state.cluster.group) {
        selectedGroup.options.push({
          label: this.$store.state.cluster.group[key].name,
          value: key
        })
      }

      return selectedGroup
    }
  },
  updated() {
    const config = this.config

    this.$emit('update', this.config)
  }
})
